var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTransfans = function SvgTransfans(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4324 20.9854L22.5572 13.8341C22.6546 13.7364 22.652 13.5779 22.5545 13.4828L20.3763 11.3535L15.4825 6.56397L17.0101 5.03174L8.27344 13.7998L15.4324 20.9854ZM13.0303 10.5478C13.831 10.5029 14.4947 11.1422 14.4947 11.9373C14.4947 12.5397 14.1128 13.0495 13.5808 13.245C13.4438 13.2952 13.3753 13.4484 13.4359 13.5805L14.4236 15.7679H11.8319L12.7932 13.5726C12.8486 13.4458 12.7827 13.2978 12.6536 13.2503C12.0953 13.0548 11.7002 12.5159 11.7239 11.8845C11.7476 11.1739 12.3218 10.5847 13.0303 10.5478Z",
    fill: "url(#paint0_linear_20311_98180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96861 11.4855L4.36719 9.87671L5.96861 11.4855Z",
    fill: "#F385A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1613 2.69371C22.8522 1.38075 21.1349 0.725586 19.4203 0.725586C17.7029 0.725586 15.9856 1.38339 14.6739 2.69899L13.9127 3.47039L13.1252 4.26556L10.7889 6.62995L7.47281 9.985L5.96094 11.4855L8.26561 13.7997L17.0023 5.03168C17.7108 4.32104 18.6749 3.96176 19.6863 4.03573C20.3895 4.08856 21.0638 4.36331 21.6064 4.81769C23.1657 6.12537 23.2447 8.46862 21.8408 9.87933L21.3799 10.3443C21.2982 10.4262 21.3009 10.5583 21.3825 10.6375L23.4475 12.6558C23.5265 12.7324 23.653 12.7324 23.732 12.6532L24.1718 12.212C26.7847 9.58081 26.7847 5.31963 24.1613 2.69371Z",
    fill: "url(#paint1_linear_20311_98180)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7966 6.62989L13.1329 4.2655L11.5315 2.69629L9.20312 5.02898L10.7966 6.62989Z",
    fill: "url(#paint2_linear_20311_98180)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.427 20.9853L13.1908 23.2282C13.1408 23.2784 13.0591 23.2784 13.0091 23.2282L2.03357 12.2094C-0.584545 9.58081 -0.584545 5.31963 2.0362 2.69371C3.34526 1.38075 5.06257 0.725586 6.77725 0.725586C8.49457 0.725586 10.2119 1.38339 11.5236 2.69899L13.125 4.26556L10.7887 6.62995L9.23996 5.07395C8.58939 4.41879 7.70966 4.0278 6.78779 4.02516C5.87118 4.02252 5.00989 4.37916 4.36195 5.02904C3.02919 6.36577 3.02655 8.53995 4.35932 9.87933L15.427 20.9853Z",
    fill: "url(#paint3_linear_20311_98180)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20311_98180",
    x1: 12.5714,
    y1: 9.34783,
    x2: 19.3347,
    y2: 16.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FB9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F385A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20311_98180",
    x1: 11.5283,
    y1: 15.454,
    x2: 19.5416,
    y2: 7.33711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FB9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F385A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20311_98180",
    x1: 11.9168,
    y1: 5.46359,
    x2: 10.9068,
    y2: 4.36908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3.73802e-7,
    stopColor: "#1E8CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20311_98180",
    x1: 2.93966,
    y1: 2.92321,
    x2: 16.9172,
    y2: 18.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000361428,
    stopColor: "#52C5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F385A3"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTransfans);
export default ForwardRef;